// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../../../graphql/api/index';

export const QuestionnaireConditionIsNotEmptyFragmentDoc = `
    fragment questionnaireConditionIsNotEmpty on QuestionnaireConditionIsNotEmpty {
  __typename
  question {
    id
  }
}
    `;